<template>
	<div>
		<div v-for="(item,index) in list" :key="index" class="cmbc_list_item width_100 border_radius_16" 
		@click="nextPage(item)">
			<van-image class="cmbc_list_item_pic width_100 border_radius_16" fit="cover" :src="item.image" />
			<div class="cmbc_list_item_body width_100">
				<div class="cmbc_list_item_title width_100 font_size_32 color_333333 text_ellipsis">{{item.venueName}}</div>
				<div class="cmbc_list_item_address width_fit text_ellipsis font_size_24 color_999999">
					{{item.venueAddress}}
				</div>
				<div class="cmbc_list_item_btn color_ffffff font_size_28 display_center_center">立即预订</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			list: {
				type: Array,
				required: true
			},
		},
		data() {
			return {}
		},
		mounted() {},
		methods: {
			nextPage(e){
				this.$router.push({
					name:'cmbc_cr_detail_1',
					params:{
						service_id:e.serviceId
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;
	.cmbc_list_item{
		background: #F6F7F9;
		margin-bottom: 30*@vm_base;
		overflow: hidden;
		.cmbc_list_item_pic{
			height: 345*@vm_base;
			overflow: hidden;
		}
		.cmbc_list_item_body{
			padding: 20*@vm_base 180*@vm_base 20*@vm_base 20*@vm_base;
			position: relative;
			.cmbc_list_item_title{
				line-height: calc(50 / 30);
			}
			.cmbc_list_item_address{
				max-width: 100%;
				line-height: 1.3;
				// margin-top: 4*@vm_base;
				padding-right: 6*@vm_base;
				// background-image: url(../resource/fly.png);
				// background-repeat: no-repeat;
				// background-position: right center;
				// background-size: auto 26*@vm_base;
				position: relative;
				padding-left: 30*@vm_base;
				&::after{
					position: absolute;
					top: 0;
					left: 0;
					content: '';
					height: 100%;
					width: 30*@vm_base;
					border-radius: 50%;
					// background-color: #FFEFE3;
					background-image: url(../resource/location.png);
					background-repeat: no-repeat;
					background-position: left center;
					background-size:auto 90%;
				}
			}
			.cmbc_list_item_btn{
				position: absolute;
				bottom: 20*@vm_base;
				right: 20*@vm_base;
				width: 160*@vm_base;
				height: 60*@vm_base;
				background: linear-gradient(233deg, #FB8027 0%, #FFA663 100%);
				border-radius: 30*@vm_base;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/list_1.vue